import React, { useEffect, useState } from "react";
import classes from "./MobileFooter.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";
import {
  logo as MainLogo,
  instaIcon,
  facebookIconWhite,
  tiktokIcon,
} from "../../constant/imagePath";
import { InputWithButton } from "../InputWithButton/InputWithButton";
import { ReactSVG } from "react-svg";
import { useHistory } from "react-router";
import { Link } from "react-router-dom";

export const MobileFooter = ({
  AppLogo,
  socialArray,
  pagesArray,
  copyRightText,
  backgroundColor,
}) => {
  const history = useHistory()
  return (
    <div
      className={classes.container}
      style={{ backgroundColor: backgroundColor }}
    >
      <Row className={[classes.innerBox, "gx-0"].join(" ")}>
        <Col lg={6} sm={6} xs={6}>
          <div>
            <img src={AppLogo} />
          </div>
        </Col>
        <Col lg={6} sm={6} xs={6} className={classes.itemsCenter}>
          <Link to={'/socialSignupCoach'}>
            <p
              style={{
                ...Fonts.b2,
                color: Colors.white,
                fontFamily: "inter-400",
                lineHeight: "20px",
              }}
            >
              Become a coach
            </p>
          </Link>

        </Col>
        <Col
          sm={12}
          className={classes.borderBottom}
          style={{
            marginTop: "30px",
            marginBottom: "22px",
            borderBottomColor: Colors.neutralShadesOfDimGray,
          }}
        />
        {pagesArray?.map((item) => {
          return (
            <Col sm={6} xs={6}>
              <p
                className={classes.pageLink}
                style={{
                  ...Fonts.b2,
                  color: Colors.white,
                  fontFamily: "inter-400",
                  lineHeight: "20px",
                }}
                onClick={() => history.push(item?.link)}
              >
                {item?.title}
              </p>
            </Col>
          );
        })}
        <Col
          sm={12}
          className={classes.borderBottom}
          style={{
            marginTop: "22px",
            marginBottom: "24px",
            borderBottomColor: Colors.neutralShadesOfDimGray,
          }}
        />
        <Col sm={12} style={{ marginBottom: "8px" }}>
          <p
            style={{
              ...Fonts.p2,
              fontSize: "12px",
              color: Colors.neutralShadesOfPinkSwan,
              lineHeight: "16px",
            }}
          >
            The best trainer lists right in your inbox
          </p>
        </Col>
        <Col sm={12}>
          <InputWithButton
            customStyle={{ width: "100%", height: "48px" }}
            inputStyle={{ padding: "16px 0px 16px 16px", height: "48px" }}
          // buttonStyle={{ top: "8px", bottom: "8px" }}
          />
        </Col>
        <Col sm={12} className={classes.socialMedia}>
          <span
            style={{
              ...Fonts.b2,
              color: Colors.white,
              lineHeight: "20px",
              fontFamily: "inter-400",
            }}
          >
            Social media:
          </span>
          <ul className={classes.socialIcons}>
            {socialArray?.map((item) => {
              return (
                <li>
                  <a href={item?.link} target="_blank">
                    <ReactSVG
                      src={item?.icon}
                      beforeInjection={(svg) => {
                        svg.classList.add(`${[classes.socialIcon].join(" ")}`);
                      }}
                    />
                  </a>
                </li>
              );
            })}
          </ul>
        </Col>
        <Col
          sm={12}
          className={classes.borderBottom}
          style={{
            // marginBottom: "16px",
            borderBottomColor: Colors.neutralShadesOfDimGray,
          }}
        />
      </Row>
      <div className={classes.lastLine}>
        <p style={{ ...Fonts.p4, color: Colors.neutralShadesOfDimGray }}>
          {copyRightText}
        </p>
        <div>
          <span style={{ ...Fonts.p4, color: Colors.neutralShadesOfDimGray }}>
            Privacy
          </span>
          <span
            className={classes.break}
            style={{ backgroundColor: Colors.neutralShadesOfDimGray }}
          />
          <span style={{ ...Fonts.p4, color: Colors.neutralShadesOfDimGray }}>
            Terms
          </span>
        </div>
      </div>
    </div>
  );
};

MobileFooter.propTypes = {
  logo: PropTypes.string,
  socialIcons: PropTypes.array,
  links: PropTypes.array,
};
MobileFooter.defaultProps = {
  AppLogo: MainLogo,
  socialArray: [
    { icon: facebookIconWhite, link: "https://www.facebook.com" },
    { icon: instaIcon, link: "https://www.instagram.com" },
    { icon: tiktokIcon, link: "https://www.tiktok.com" },
  ],
  pagesArray: [
    { title: "Partnership", link: "/partnership" },
    { title: "FAQ", link: "/help" },
    { title: "Become an investor", link: "/become-an-investor" },
    { title: "Contact us", link: "/contact-us" },
  ],
  copyRightText: "©2021 Lytesnap.com",
  backgroundColor: Colors.neutralShadesOfNero,
};
